import React from "react";
import { z } from "zod";
import { registerUser } from "./api";
import TempalateForm from "./TemplateForm";
import DynamicForm from "../../components/DynamicForm";

// Schema Zod untuk validasi
const schema = z.object({
  email: z.string().email({ message: "Email tidak valid" }),
  username: z.string().min(3, { message: "Username minimal 3 karakter" }),
  password: z.string().min(6, { message: "Password minimal 6 karakter" }),
});

const FormRegister = () => {
  // Definisi fields untuk form register
  const fields = [
    {
      name: "username",
      placeholder: "Username",
    },
    {
      name: "email",
      type: "email",
      placeholder: "Email",
    },
    {
      name: "password",
      type: "password",
      placeholder: "Password",
    },
  ];

  // Fungsi untuk menangani submit form
  const onSubmit = async (data) => {
    try {
      const result = await registerUser(data);
      if (result.success) {
        alert("Registrasi berhasil! Silakan login.");
        window.location.href = "/login";
      } else {
        alert("Registrasi gagal: " + result.message);
      }
    } catch (error) {
      alert("Terjadi kesalahan, silakan coba lagi.");
    }
  };

  return (
    <TempalateForm>
      <h1 className="form-title">Form Register</h1>
      <DynamicForm schema={schema} fields={fields} onSubmit={onSubmit} />
    </TempalateForm>
  );
};

export default FormRegister;
